<script>
import { DateElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/date-element-mixin";
import {
  CollectionCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-collection-card/collection-card-element-mixin";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";

export default {
  name: "CollectionCreated",
  elementPanelSettings: {
    displayName: "Collection Created",
    displayIcon: "text-alt",
    elementType: "element",
    elementGroup: "collectionElements",
  },
  extends: UrlElement,
  mixins: [CollectionCardElementMixin, DateElementMixin],
  computed: {
    label() {
      return `Created ${this.formattedDate(this.entity.timestampCreated)}`;
    },
    computedHref() {
      return useGeneralStore().getRelativeHref(`/collection-items/${this.entity.collectionId}`);
    },
    shouldShowLink() {
      return !!this.label;
    },
  },
};
</script>
